// extracted by mini-css-extract-plugin
export default {"card":"CardArrow_card__0i5ZS","type":"CardArrow_type__m7z3w","icon":"CardArrow_icon__rKMnj","text":"CardArrow_text__e-wzK","color":"CardArrow_color__sAxvD"};